import { render, staticRenderFns } from "./BookmarksMenu.vue?vue&type=template&id=55f65454&scoped=true"
import script from "./BookmarksMenu.vue?vue&type=script&lang=ts"
export * from "./BookmarksMenu.vue?vue&type=script&lang=ts"
import style0 from "./BookmarksMenu.vue?vue&type=style&index=0&id=55f65454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f65454",
  null
  
)

export default component.exports